{
  "title": "autobrr",
  "username": "Nom d'utilisateur",
  "password": "Mot de passe",
  "confirmPassword": "Confirmer le mot de passe",
  "createAccount": "Créer un compte",
  "rememberMe": "Se souvenir de moi",
  "forgotPassword": "Mot de passe oublié?",
  "forgotPasswordHelp": "Réinitialiser via le terminal:",
  "signIn": "Se connecter",
  "continueWith": "Ou continuer avec",
  "openidConnect": "OpenID Connect",
  "errors": {
    "required": "Requis",
    "usernameRequired": "Le nom d'utilisateur est requis",
    "passwordRequired": "Le mot de passe est requis",
    "passwordsDoNotMatch": "Les mots de passe ne correspondent pas!",
    "generic": "Une erreur s'est produite !",
    "oidcFailed": "Échec de l'authentification OIDC"
  }
}
